export default {
  "大阪府立近つ飛鳥博物館": {
    address: '大阪府南河内郡河南町',
    lat: 34.5033014557965,
    lng: 135.64331966899834
  },
  "堺市博物館": {
    address: '大阪府堺市堺区百舌鳥夕雲町',
    lat: 34.55894630915716,
    lng: 135.48427015116744
  },
  "堺市立みはら歴史博物館": {
    address: '大阪府堺市美原区黒山',
    lat: 34.54798467001166,
    lng: 135.5598774689995
  },
  "羽曳野市文化財展示室": {
    address: '大阪府羽曳野市誉田',
    lat: 34.556967544603886,
    lng: 135.605623197836
  },
  "藤井寺市アイセルシュラホール": {
    address: '大阪府藤井寺市藤井寺',
    lat: 34.56602713615161,
    lng: 135.59734126899994
  },
  "藤井寺市城山古墳ガイダンス棟": {
    address: '大阪府藤井寺市小山',
    lat: 34.58292171424547,
    lng: 135.5931652401632
  }
}


// WEBPACK FOOTER //
// ./map/js/ih/data/mozu-furu-artifact_museum_data.js